<template>
    <v-row class="justify-center">
        <overlay/>
        <v-col cols="12" md="7">
            <ValidationObserver>
                <v-card>
                    <v-card-text>
                        <form action="" method="POST" @submit.prevent="save">
                            <v-row dense>
                                <v-col cols="12">
                                    <ValidationProvider name="name" rules="required|max:255" v-slot="{ errors }">
                                        <v-text-field
                                                label="Name"
                                                name="name"
                                                id="name"
                                                v-model="name"
                                                outlined
                                                :error-messages="errors[0]"
                                        ></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12">
                                    <ValidationProvider name="email" rules="required|email|max:255" v-slot="{ errors }">
                                        <v-text-field
                                                label="Email Address"
                                                name="email"
                                                id="email"
                                                v-model="email"
                                                outlined
                                                :error-messages="errors[0]"
                                        ></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12">
                                    <ValidationProvider name="role" rules="integer" v-slot="{ errors }">
                                        <v-autocomplete
                                                :items="roles"
                                                item-text="name"
                                                item-value="id"
                                                name="role"
                                                id="role"
                                                label="Role"
                                                v-model="role"
                                                outlined
                                                :error-messages="errors[0]"
                                        ></v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                            :items="professions"
                                            item-text="name"
                                            item-value="id"
                                            name="profession"
                                            id="profession"
                                            label="Profession"
                                            v-model="profession"
                                            outlined
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" v-if="mode === 'create'">
                                    <ValidationProvider name="password" rules="required|min:8|max:255"
                                                        v-slot="{ errors }">
                                        <v-text-field
                                                label="Password"
                                                name="password"
                                                id="password"
                                                type="password"
                                                v-model="password"
                                                outlined
                                                :error-messages="errors[0]"
                                        ></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" v-if="mode === 'edit'">
                                    <ValidationProvider name="adminNote" rules="max:10000" v-slot="{ errors }">
                                        <v-textarea
                                                label="Note"
                                                name="admin_note"
                                                id="adminNote"
                                                type="adminNote"
                                                v-model="adminNote"
                                                outlined
                                                :error-messages="errors[0]"
                                        ></v-textarea>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                        </form>
                    </v-card-text>
                </v-card>
            </ValidationObserver>
        </v-col>

        <v-col cols="12" md="3">
            <v-card>
                <v-card-text>
                    <v-row dense class="mb-4">

                        <!-- Save Button -->
                        <v-col cols="12">
                            <v-btn type="submit"
                                   color="primary"
                                   @click="save"
                                   width="100%"
                                   :disabled="userSaving"
                            >
                                <v-icon v-if="userSaving" left small>fas fa-spin fa-sync-all</v-icon>
                                <v-icon v-else left small>fas fa-save</v-icon>
                                Save
                            </v-btn>
                        </v-col>

                        <!-- Export Button -->
                        <v-col cols="12" v-if="allowCloseProject()">
                            <v-btn v-if="mode === 'edit'"
                                   type="submit"
                                   color="secondary"
                                   @click="download"
                                   width="100%"
                            >
                                <v-icon left small>fas fa-download</v-icon>
                                Export
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <!-- Tracking Button -->
                        <v-col cols="12" v-if="mode === 'edit'">
                            <v-btn v-if="roleName === 'support'" x-small text :to="'/user/tracking/' + userId">
                                <v-icon x-small left>fas fa-file</v-icon>
                                View Tracking Report
                            </v-btn>
                        </v-col>

                        <!-- Change Password Button -->
                        <v-col cols="12" v-if="mode === 'edit'">
                            <v-btn x-small text @click="changePassModal = true">
                                <v-icon x-small left>fas fa-lock</v-icon>
                                Change Password
                            </v-btn>
                        </v-col>

                        <!-- Close Project Button -->
                        <v-col cols="12" v-if="mode === 'edit' && roles && allowCloseProject()">
                            <v-btn x-small
                                   text
                                   @click="closeProjectModal = true"
                            >
                                <v-icon x-small left>fas fa-minus-circle</v-icon>
                                Close Project
                            </v-btn>
                        </v-col>

                        <!-- Delete User Button -->
                        <v-col cols="12" v-if="mode === 'edit' && !deleteDisabled">
                            <v-btn x-small text @click="deleteModal = true">
                                <v-icon x-small left>fas fa-user-slash</v-icon>
                                Delete User
                            </v-btn>
                        </v-col>

                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

        <!-- Token Model -->
        <v-dialog max-width="500" v-if="mode === 'edit'" v-model="tokenModal">
            <v-card>
                <v-card-title>Token</v-card-title>
                <v-card-text>
                    {{ tokenMessage ? tokenMessage : 'error' }} <code>{{ token ? token : '' }}</code>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="tokenModal = !tokenModal">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Change Password Modal -->
        <v-dialog max-width="500" v-if="mode === 'edit'" v-model="changePassModal">
            <v-card>
                <v-card-title>Change Password</v-card-title>
                <v-card-text>
                    <form action="" id="changePasswordForm" method="POST" @submit.prevent="changePassword">
                        <ValidationObserver v-slot="{invalid}">
                            <ValidationProvider name="password"
                                                rules="required|min:8|max:255|confirmed:confirmation"
                                                v-slot="{ errors }"
                                                mode="lazy"
                            >
                                <v-text-field
                                        label="Password"
                                        name="password"
                                        id="password"
                                        type="password"
                                        v-model="newPassword"
                                        outlined
                                        :error-messages="errors[0]"
                                ></v-text-field>
                            </ValidationProvider>
                            <ValidationProvider name="passwordConfirmation"
                                                rules="required|min:8|max:255"
                                                v-slot="{ errors }"
                                                vid="confirmation"
                                                mode="lazy"
                            >
                                <v-text-field
                                        label="Confirm Password"
                                        name="confirmPassword"
                                        id="confirmPassword"
                                        type="password"
                                        v-model="confirmation"
                                        outlined
                                        :error-messages="errors[0]"
                                ></v-text-field>
                            </ValidationProvider>
                            <v-card-actions class="ma-0 pa-0">
                                <v-spacer></v-spacer>
                                <v-btn text @click="cancelChangePassword">Cancel</v-btn>
                                <v-btn form="changePasswordForm" type="submit" color="primary" :disabled="invalid">
                                    Change
                                </v-btn>
                            </v-card-actions>
                        </ValidationObserver>
                    </form>
                </v-card-text>
            </v-card>

        </v-dialog>

        <!-- Close Project Modal -->
        <v-dialog v-model="closeProjectModal" width="500" v-if="mode === 'edit' && !deleteDisabled">
            <v-card>
                <v-card-title>
                    Close Project
                </v-card-title>
                <v-card-text>
                    Closing this project will permanently remove all user data and demote the user to the "support"
                    role. Tracking numbers will be created for this user.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeProjectModal = false">Cancel</v-btn>
                    <v-btn v-if="!deleteDisabled"
                           :disabled="projectClosing"
                           color="primary"
                           @click="close"
                    >
                        <v-icon v-if="projectClosing" color="primary" small left>fas fa-spin fa-sync-alt</v-icon>
                        <v-icon v-else small left>fas fa-minus-circle</v-icon>
                        Close Project
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Delete User Modal -->
        <v-dialog v-model="deleteModal" width="500" v-if="mode === 'edit' && !deleteDisabled">
            <v-card>
                <v-card-title> Delete User: {{ name }}</v-card-title>

                <v-card-text>
                    You are about to remove this user and remove all of their data. This cannot be undone. This user
                    will no longer have access to the platform.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="deleteModal = false">
                        Cancel
                    </v-btn>
                    <v-btn v-if="!deleteDisabled" color="primary" @click="destroy">
                        Delete User
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Overlay from '../../../../components/Overlay';
import store from '../../../../store/store';
import exportProject from '@/helpers/exportProject';
import notify from '@/store/Common/notify';

export default {
    components: { Overlay },
    props: ['mode'],

    computed: {
        userId: function() {
            return this.$route.params.id;
        },

        tokenModal: {
            get() {
                return store.getters['userEditor/tokenModal'];
            },
            set(value) {
                this.setTokenModal(value);
            }
        },

        userSaving() {
            return store.getters['userEditor/userSaving'];
        },

        name: {
            get: function() {
                return store.getters['userEditor/name'];
            },
            set: function(value) {
                this.setName(value);
            }
        },

        adminNote: {
            get: function() {
                return store.getters['userEditor/adminNote'];
            },
            set: function(value) {
                this.setAdminNote(value);
            }
        },

        email: {
            get: function() {
                return store.getters['userEditor/email'];
            },
            set: function(value) {
                this.setEmail(value);
            }
        },

        password: {
            get: function() {
                return store.getters['userEditor/password'];
            },
            set: function(value) {
                this.setPassword(value);
            }
        },

        profession: {
            get: function() {
                return store.getters['userEditor/profession'];
            },
            set: function(value) {
                this.setProfession(value);
            }
        },

        role: {
            get: function() {
                return store.getters['userEditor/role'];
            },
            set: function(value) {
                this.setRole(value);
            }
        },

        roleName: {
            get: function() {
                return store.getters['userEditor/roleName'];
            }
        },

        projectClosing() {
            return store.getters['userEditor/projectClosing'];
        },

        ...mapGetters({
            roles: 'userEditor/roles',
            professions: 'userEditor/professions',
            deleteDisabled: 'userEditor/deleteDisabled'
        })
    },

    data() {
        return {
            deleteModal: false,
            closeProjectModal: false,
            changePassModal: false,
            newPassword: undefined,
            confirmation: undefined,
            showUserId: false
        };
    },

    mounted() {
        const id = this.$route.params.id ? this.$route.params.id : 0;
        this.setId(id);
        this.getData();
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'userEditor/getData',
            saveData: 'userEditor/saveData',
            destroyData: 'userEditor/destroyData',
            adminChangePassword: 'userEditor/adminChangePassword',
            closeProject: 'userEditor/closeProject',
        }),

        ...mapMutations({
            toggleOverlay: 'overlay/toggle',
            setId: 'userEditor/setUserId',
            setName: 'userEditor/setName',
            setEmail: 'userEditor/setEmail',
            setPassword: 'userEditor/setPassword',
            setRole: 'userEditor/setRole',
            setProfession: 'userEditor/setProfession',
            setAdminNote: 'userEditor/setAdminNote',
        }),

        save() {
            this.saveData();
        },

        destroy() {
            this.deleteModal = false;
            this.destroyData();
        },

        download() {
            exportProject(this.userId, this.name);
        },

        changePassword() {
            this.adminChangePassword(this.newPassword)
                .then(() => {
                    notify('Password Changed Successfully', 'success');
                    this.clearPasswordReset();
                })

                .catch(() => {
                    notify('Password Not Changed', 'error');
                });
        },

        cancelChangePassword() {
            this.clearPasswordReset();
        },

        clearPasswordReset() {
            this.newPassword = '';
            this.confirmation = '';
            this.changePassModal = false;
        },

        close() {
            this.closeProject()
                .then(() => {
                    this.getData();
                    this.closeProjectModal = false;
                    notify('Project Closed Successfully', 'success');
                })
                .catch((error) => {
                    notify('Project Close Failure: Check Console for Error', 'error');
                    console.error(error);
                });
        },

        allowCloseProject() {
            if (this.deleteDisabled) {
                return false;
            }

            if (this.roles[this.role - 1].name === 'support') {
                return false;
            }

            if (this.roles[this.role - 1].name === 'admin') {
                return false;
            }

            if (this.roles[this.role - 1].name === 'builder') {
                return false;
            }

            return true;
        }
    }
};
</script>
